<div class="container-fluid py-4" [ngBusy]="busy">

  <div class="row mb-4">
    <div class="col-12">
      <div class="card border-0 shadow-sm header-card">
        <div class="card-body py-4 px-5">
          <h4 class="text-white mb-0 fw-bold">
            <i class="fas fa-paper-plane me-2"></i>
            Envoyer un lien de paiement
          </h4>
          <p class="text-white-50 mb-0 mt-1 small">
            Générez et envoyez un lien sécurisé et personnalisé à votre client
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4">

    <!-- Colonne gauche -->
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm h-100" style="border-radius: 16px;">
        <div class="card-body p-5">

          <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">

            <!-- Type de paiement -->
            <div class="mb-5">
              <label class="form-label fw-bold text-dark fs-6 mb-3">
                <i class="fas fa-credit-card me-2 text-primary"></i>
                Type de paiement
              </label>
              <div class="row g-3">

                <div class="col-md-6">
                  <div class="payment-type-card"
                       [class.selected]="paymentForm.get('type')?.value === 'one_shot'"
                       (click)="paymentForm.get('type')?.setValue('one_shot')">
                    <div class="text-center py-4 px-3">
                      <div class="icon-wrapper mb-3"
                           [class.icon-active]="paymentForm.get('type')?.value === 'one_shot'">
                        <i class="fas fa-bolt fa-2x"></i>
                      </div>
                      <p class="fw-bold mb-1">Paiement unique</p>
                      <p class="text-muted mb-0 small">Le client paie une seule fois</p>
                      <span class="badge mt-2"
                            [class.badge-active]="paymentForm.get('type')?.value === 'one_shot'"
                            [class.badge-inactive]="paymentForm.get('type')?.value !== 'one_shot'">
                        One-shot
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="payment-type-card"
                       [class.selected]="paymentForm.get('type')?.value === 'subscription'"
                       (click)="paymentForm.get('type')?.setValue('subscription')">
                    <div class="text-center py-4 px-3">
                      <div class="icon-wrapper mb-3"
                           [class.icon-active]="paymentForm.get('type')?.value === 'subscription'">
                        <i class="fas fa-sync-alt fa-2x"></i>
                      </div>
                      <p class="fw-bold mb-1">Abonnement mensuel</p>
                      <p class="text-muted mb-0 small">Prélèvement automatique mensuel</p>
                      <span class="badge mt-2"
                            [class.badge-active]="paymentForm.get('type')?.value === 'subscription'"
                            [class.badge-inactive]="paymentForm.get('type')?.value !== 'subscription'">
                        Récurrent
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Montant -->
            <div class="mb-5">
              <label class="form-label fw-bold text-dark fs-6 mb-3">
                <i class="fas fa-euro-sign me-2 text-primary"></i>
                Montant
                <span *ngIf="isSubscription" class="text-muted fw-normal small ms-1">
                  (prélevé chaque mois)
                </span>
              </label>
              <div class="input-group input-group-lg">
                <input
                  type="number"
                  class="form-control amount-input"
                  formControlName="montant"
                  placeholder="0.00"
                  min="1"
                  step="0.01">
                <span class="input-group-text euro-badge">€</span>
              </div>

              <!-- Info abonnement -->
              <div *ngIf="isSubscription && paymentForm.get('montant')?.value"
                   class="info-box mt-3">
                <i class="fas fa-info-circle me-2 text-primary"></i>
                Le client sera prélevé de
                <strong>{{ paymentForm.get('montant')?.value | number:'1.2-2' }} €</strong>
                automatiquement chaque mois.
              </div>
            </div>

            <!-- Recherche client -->
            <div class="mb-5">
              <label class="form-label fw-bold text-dark fs-6 mb-3">
                <i class="fas fa-search me-2 text-primary"></i>
                Rechercher un client
              </label>

              <div *ngIf="selectedClient" class="selected-client-card">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="avatar-circle me-3">
                      {{ selectedClient.company_name?.charAt(0)?.toUpperCase() }}
                    </div>
                    <div>
                      <p class="mb-0 fw-bold text-dark fs-6">{{ selectedClient.company_name }}</p>
                      <p class="mb-0 text-muted small">
                        <i class="fas fa-user me-1"></i>{{ selectedClient.director_name }}
                        &nbsp;·&nbsp;
                        <i class="fas fa-envelope me-1"></i>{{ selectedClient.email }}
                      </p>
                    </div>
                  </div>
                  <button type="button"
                          class="btn btn-outline-danger btn-sm px-3"
                          [disabled]="isLoading"
                          (click)="clearClient()">
                    <i class="fas fa-times me-1"></i> Changer
                  </button>
                </div>
              </div>

              <div *ngIf="!selectedClient" class="position-relative">
                <div class="input-group input-group-lg">
                  <span class="input-group-text bg-white border-end-0">
                    <i *ngIf="!isSearching" class="fas fa-search text-muted"></i>
                    <span *ngIf="isSearching"
                          class="spinner-border spinner-border-sm text-primary"></span>
                  </span>
                  <input
                    type="text"
                    class="form-control search-input border-start-0"
                    placeholder="Nom société, directeur ou email... (min. 3 caractères)"
                    [value]="searchQuery"
                    [disabled]="isLoading"
                    (input)="onSearchChange($any($event.target).value)">
                </div>

                <p *ngIf="isSearching" class="text-primary small mt-2 ms-1">
                  <span class="spinner-border spinner-border-sm me-1"></span>
                  Recherche en cours...
                </p>
                <p *ngIf="!isSearching && searchQuery.length < 3"
                   class="text-muted small mt-2 ms-1">
                  <i class="fas fa-lightbulb me-1 text-warning"></i>
                  Saisissez au moins 3 caractères pour lancer la recherche
                </p>
                <p *ngIf="!isSearching && searchQuery.length >= 3 && clientResults.length === 0 && !showDropdown"
                   class="text-danger small mt-2 ms-1">
                  <i class="fas fa-exclamation-circle me-1"></i>
                  Aucun client trouvé pour "{{ searchQuery }}"
                </p>

                <div *ngIf="showDropdown" class="dropdown-results shadow-lg">
                  <div *ngFor="let client of clientResults"
                       class="dropdown-item-custom"
                       (click)="selectClient(client)">
                    <div class="d-flex align-items-center p-3">
                      <div class="avatar-circle-sm me-3">
                        {{ client.company_name?.charAt(0)?.toUpperCase() }}
                      </div>
                      <div>
                        <p class="mb-0 fw-semibold text-dark">{{ client.company_name }}</p>
                        <p class="mb-0 text-muted small">
                          <i class="fas fa-user me-1"></i>{{ client.director_name }}
                          &nbsp;·&nbsp;
                          <i class="fas fa-envelope me-1"></i>{{ client.email }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Bouton Submit -->
            <div class="d-grid">
              <button
                type="submit"
                class="btn btn-primary btn-lg submit-btn py-3 fw-bold"
                [disabled]="paymentForm.invalid || !selectedClient || isLoading">
                <span *ngIf="!isLoading">
                  <i class="fas fa-paper-plane me-2"></i>
                  Envoyer le lien de paiement
                </span>
                <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Envoi en cours...
                </span>
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>

    <!-- Colonne droite — Résumé -->
    <div class="col-lg-4">
      <div class="card border-0 shadow-sm" style="border-radius: 16px;">
        <div class="card-body p-4">
          <h6 class="fw-bold text-dark mb-4">
            <i class="fas fa-eye me-2 text-primary"></i>
            Résumé de l'envoi
          </h6>

          <div class="summary-item">
            <span class="summary-label">
              <i class="fas fa-tag me-2 text-muted"></i>Type
            </span>
            <span class="summary-value">
              <span *ngIf="!isSubscription" class="badge bg-info text-white">
                Paiement unique
              </span>
              <span *ngIf="isSubscription" class="badge bg-purple text-white">
                Abonnement mensuel
              </span>
            </span>
          </div>

          <div class="summary-item">
            <span class="summary-label">
              <i class="fas fa-euro-sign me-2 text-muted"></i>Montant
            </span>
            <span class="summary-value fw-bold text-dark">
              {{ paymentForm.get('montant')?.value
                ? (paymentForm.get('montant')?.value | number:'1.2-2') + ' €'
                : '—' }}
            </span>
          </div>

          <div class="summary-item">
            <span class="summary-label">
              <i class="fas fa-building me-2 text-muted"></i>Client
            </span>
            <span class="summary-value">
              {{ selectedClient ? selectedClient.company_name : '—' }}
            </span>
          </div>

          <div class="summary-item border-0 pb-0">
            <span class="summary-label">
              <i class="fas fa-envelope me-2 text-muted"></i>Email
            </span>
            <span class="summary-value small">
              {{ selectedClient ? selectedClient.email : '—' }}
            </span>
          </div>

          <div class="validity-info mt-3">
            <i class="fas fa-clock me-2 text-warning"></i>
            <small>Lien valable <strong>7 jours</strong> après envoi</small>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>